export default function initCarSales() {
  document.querySelectorAll(".car-tab").forEach(function (button) {
    button.addEventListener("click", function () {
      let tabToActivate, tabToHide, focusedButton, unfocusedButton
      let carId = this.dataset.carId
      let tabType = this.dataset.tabType

      tabToActivate = document.getElementById(tabType + "-" + carId)
      focusedButton = document.getElementsByClassName(tabType + "-button-" + carId)[0]

      if (tabType === "overview") {
        tabToHide = document.getElementById("features-" + carId)
        unfocusedButton = document.querySelector(".features-button-" + carId)
      } else {
        tabToHide = document.getElementById("overview-" + carId)
        unfocusedButton = document.querySelector(".overview-button-" + carId)
      }

      if ((tabToActivate.style.display = "none")) {
        tabToActivate.style.display = "inline-block"
        tabToHide.style.display = "none"

        focusedButton.classList.add("active")
        unfocusedButton.classList.remove("active")
      }
    })
  })
}